(function () {
  function movePriorityBox() {
    const forms = document.querySelectorAll('form.product-single__form');

    forms.forEach(function (form) {
      const priorityBox = form.querySelector('.cutxi-priority-box');
      const paymentButtons = form.querySelector('.payment-buttons');
      const addButton = form.querySelector('[data-add-to-cart], button[name="add"]');

      if (!priorityBox || !addButton) return;

      /*
        Queremos colocar a prioridade antes da zona dos botões.
        Se existir .payment-buttons, usamos esse bloco como referência.
        Se não existir, usamos o botão diretamente.
      */
      const target = paymentButtons || addButton;

      if (priorityBox.nextElementSibling === target) return;

      target.parentNode.insertBefore(priorityBox, target);
    });
  }

  function updatePriorityFeedback() {
    const forms = document.querySelectorAll('form.product-single__form');

    forms.forEach(function (form) {
      const feedback = form.querySelector('[data-cutxi-priority-feedback]');
      const selected = form.querySelector('input[name="properties[_urgency_level]"]:checked');
      const groupInput = form.querySelector('input[name="properties[_urgency_group]"]');

      if (!feedback || !selected) return;

      const value = selected.value;
      const isBatizado = groupInput && groupInput.value === 'batizado';

      let message = '';

      if (!value) {
  message = 'Sem prioridade. Mantém-se o prazo base.';
} else if (isBatizado) {
  if (value === 'prioritaria') {
    message = 'Prioritário selecionado: produção em 10 a 15 dias úteis.';
  }

  if (value === 'rapida') {
    message = 'Expresso selecionado: produção em 5 a 6 dias úteis.';
  }

  if (value === 'urgente') {
    message = 'Urgente selecionado: produção em 1 dia útil.';
  }
} else {
  if (value === 'rapida') {
    message = 'Rápida selecionada: produção até 5 dias úteis.';
  }

  if (value === 'prioritaria') {
    message = 'Prioritária selecionada: produção em 3 a 4 dias úteis.';
  }

  if (value === 'urgente') {
    message = 'Urgente selecionada: produção em 1 dia útil.';
  }
}

      if (feedback.textContent !== message) {
        feedback.textContent = message;
      }
    });
  }

  function runPrioritySetup() {
    movePriorityBox();
    updatePriorityFeedback();
  }

  document.addEventListener('DOMContentLoaded', function () {
    runPrioritySetup();

    setTimeout(runPrioritySetup, 300);
    setTimeout(runPrioritySetup, 800);
    setTimeout(runPrioritySetup, 1500);
    setTimeout(runPrioritySetup, 2500);

    document.body.addEventListener('change', function (event) {
      if (event.target.matches('input[name="properties[_urgency_level]"]')) {
        updatePriorityFeedback();
      }
    });
  });
})();
(function () {
  const styleId = 'cutxi-priority-compact-styles';

  function addStyles() {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .cutxi-priority-box[data-compact-priority] {
        margin-block: 16px;
      }

      .cutxi-priority-box[data-compact-priority] > .cutxi-priority-option {
        margin-bottom: 10px;
      }

      .cutxi-priority-box[data-compact-priority] .cutxi-priority-title {
        margin: 0;
      }

      .cutxi-priority-box[data-compact-priority] .cutxi-priority-toggle {
        appearance: none;
        background: transparent;
        border: 0;
        color: inherit;
        cursor: pointer;
        font: inherit;
        font-weight: 600;
        padding: 4px 0;
        text-align: left;
        text-decoration: underline;
        text-underline-offset: 3px;
      }

      .cutxi-priority-box[data-compact-priority] .cutxi-priority-toggle:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 3px;
      }

      .cutxi-priority-box[data-compact-priority] .cutxi-priority-help {
        margin-top: 10px;
      }

      .cutxi-priority-box[data-compact-priority] .cutxi-priority-options {
        margin-top: 10px;
      }
    `;
    document.head.appendChild(style);
  }

  function initializeBox(box, index) {
    if (box.hasAttribute('data-compact-priority')) return;

    const title = box.querySelector('.cutxi-priority-title');
    const help = box.querySelector('.cutxi-priority-help');
    const options = box.querySelector('.cutxi-priority-options');
    const defaultInput = options && options.querySelector('input[name="properties[_urgency_level]"][value=""]');
    const defaultOption = defaultInput && defaultInput.closest('.cutxi-priority-option');

    if (!title || !options || !defaultOption) return;

    box.setAttribute('data-compact-priority', '');
    box.insertBefore(defaultOption, title);

    const optionsId = `cutxi-priority-options-${index}`;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cutxi-priority-toggle';
    button.textContent = title.textContent.trim();
    button.setAttribute('aria-controls', optionsId);
    button.setAttribute('aria-expanded', 'false');
    title.replaceChildren(button);
    options.id = optionsId;

    const selected = box.querySelector('input[name="properties[_urgency_level]"]:checked');
    const shouldStartOpen = selected && selected.value !== '';

    if (help) help.hidden = !shouldStartOpen;
    options.hidden = !shouldStartOpen;
    button.hidden = Boolean(shouldStartOpen);
    button.setAttribute('aria-expanded', String(Boolean(shouldStartOpen)));

    button.addEventListener('click', function () {
      if (help) help.hidden = false;
      options.hidden = false;
      button.hidden = true;
      button.setAttribute('aria-expanded', 'true');
      const firstOption = options.querySelector('input');
      if (firstOption) firstOption.focus();
    });
  }

  function initializePriorityBoxes() {
    addStyles();
    document.querySelectorAll('.cutxi-priority-box').forEach(initializeBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePriorityBoxes);
  } else {
    initializePriorityBoxes();
  }

  document.addEventListener('shopify:section:load', initializePriorityBoxes);
}());



(function () {
  function moveQuantityIntoForm(form) {
    const formId = form.getAttribute('id');
    if (!formId) return;

    const quantity = document.querySelector(`input[name="quantity"][form="${CSS.escape(formId)}"]`);
    const quantityBlock = quantity && quantity.closest('.product-block');
    const priorityBox = form.querySelector('.cutxi-priority-box');

    if (!quantityBlock || !priorityBox) return;
    if (quantityBlock.parentElement === form && quantityBlock.nextElementSibling === priorityBox) return;
    form.insertBefore(quantityBlock, priorityBox);
  }

  function initializeCustomPhrase(form) {
    const phrase = form.querySelector('select[name="properties[Frase]"]');
    const customPhrase = form.querySelector('input[name^="properties[Caso selecione"]');
    const customPhraseField = customPhrase && customPhrase.closest('.cl-po--option');

    if (!phrase || !customPhrase || !customPhraseField) return;

    function updateCustomPhrase() {
      const show = phrase.value.toLocaleLowerCase('pt-PT').includes('outra frase');
      customPhraseField.hidden = !show;
      customPhrase.disabled = !show;
    }

    if (!phrase.hasAttribute('data-cutxi-custom-phrase')) {
      phrase.setAttribute('data-cutxi-custom-phrase', '');
      phrase.addEventListener('change', updateCustomPhrase);
    }

    updateCustomPhrase();
  }

  function getTopProductBlock(element, container) {
    let block = element;

    while (block && block.parentElement !== container) {
      block = block.parentElement;
    }

    return block;
  }

  function moveTrustPoints(form) {
    const container = form.closest('[data-product-blocks]');
    if (!container) return;

    const formBlock = getTopProductBlock(form, container);
    if (!formBlock || formBlock.hasAttribute('data-cutxi-trust-moved')) return;

    const points = Array.from(container.querySelectorAll(':scope > .product-block--sales-point'));
    if (!points.length) return;

    const reference = formBlock.nextElementSibling;
    points.forEach(function (point) {
      container.insertBefore(point, reference);
    });
    formBlock.setAttribute('data-cutxi-trust-moved', '');
  }

  function unifyFreeShippingThreshold() {
    document.querySelectorAll('.product-block--sales-point').forEach(function (point) {
      const walker = document.createTreeWalker(point, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        if (textNode.nodeValue.includes('60€')) {
          textNode.nodeValue = textNode.nodeValue.replaceAll('60€', '70€');
        }
        textNode = walker.nextNode();
      }
    });
  }

  function initializeProductPage() {
    document.querySelectorAll('form.product-single__form').forEach(function (form) {
      moveQuantityIntoForm(form);
      initializeCustomPhrase(form);
      moveTrustPoints(form);
    });
    unifyFreeShippingThreshold();
  }

  let scheduled = false;
  const observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initializeProductPage();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeProductPage();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    initializeProductPage();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', initializeProductPage);
}());
